module.exports = __webpack_public_path__ + "media/react/features/event-creation-wizard/assets/templates/all-hands-089eb3be05d99d9348ad1f1157bc6e66.png";